import { render } from "./social.vue?vue&type=template&id=76c02f5b&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"

import "./social.vue?vue&type=style&index=0&id=76c02f5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c02f5b"]])

export default __exports__